import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@app/common/services/local-storage.service';
import { STORAGE } from '@app/common/constants';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit() {
    const lang = this.localStorageService.getItem<string>(STORAGE.LANGUAGE_KEY);
    this.translate.use(lang || environment.defaultLanguage);
  }
}
